import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';

export function PayproToLiberisTerms() {
  const { t } = useTranslation();

  return (
    <Stack gap="10px">
      <Typography fontWeight="medium">
        {t(
          'welcomePage.loanApplicationPossible.liberis.agreementsForm.agreements.payProToLiberisData.title',
        )}
      </Typography>
      <Typography>
        {t(
          'welcomePage.loanApplicationPossible.liberis.agreementsForm.agreements.payProToLiberisData.content',
        )}
      </Typography>
    </Stack>
  );
}
